import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useIsCustomer = () => {
	const { userTags } = useUserTags();

	return userTags.includes(tags.customer);
};
